<footer class="container-fluid sticky-footer d-none d-sm-block">
	<div class="row justify-content-center align-items-center justify-content-sm-between">
		<div class="col footer-logo" *ngIf="showBranding">
			<a [routerLink]="['/contract']" *ngIf="!isDirect">
				<img
					[attr.src]="environment.baseUrl + '/attachments/' + activeFooterLogoAttachment?.attachmentId + '/view?access_token=' + environment.apiKey"
					[attr.height]="activeFooterLogoHeight" />
			</a>
			<span *ngIf="isDirect">
				<img
					*ngIf="agent?.darkDisplayLogoAttachment?.attachmentId || activeFooterLogoAttachment"
					[attr.src]="
						environment.baseUrl +
						'/attachments/' +
						(agent?.darkDisplayLogoAttachment?.attachmentId || activeFooterLogoAttachment?.attachmentId) +
						'/view?access_token=' +
						environment.apiKey
					"
					height="45" />
			</span>
		</div>
		<div *ngIf="showBranding" class="col-auto footer-copy">Copyright &copy; {{ year }} {{ companyName }}</div>
	</div>
</footer>
